interface LogoProps {
  /** Height of the icon mark in px (wordmark scales with it). */
  size?: number;
  /** Show the "TensorMaps" wordmark next to the mark. */
  showWordmark?: boolean;
  className?: string;
}

/**
 * TensorMaps brand lockup: a map pin holding a 2×2 "tensor" grid, optionally
 * followed by the wordmark. Rendered as inline SVG so it stays crisp at any
 * size and needs no image request. The gradient id is unique per render to
 * avoid clashes when multiple logos are on the page.
 */
export function Logo({ size = 28, showWordmark = true, className = '' }: LogoProps) {
  const gid = `tmLogo-${Math.round(size)}`;
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} aria-label="TensorMaps">
      <svg width={size} height={size} viewBox="0 0 80 80" fill="none" aria-hidden="true" className="shrink-0">
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#1a73e8" />
            <stop offset="1" stopColor="#06b6a4" />
          </linearGradient>
        </defs>
        <rect width="80" height="80" rx="18" fill={`url(#${gid})`} />
        <path
          d="M40 15c-11 0-20 9-20 20 0 14 17.5 28.9 19.1 30.2a1.4 1.4 0 0 0 1.8 0C42.5 63.9 60 49 60 35c0-11-9-20-20-20z"
          fill="#fff"
        />
        <g fill={`url(#${gid})`}>
          <circle cx="35" cy="30" r="3.4" />
          <circle cx="45" cy="30" r="3.4" />
          <circle cx="35" cy="40" r="3.4" />
          <circle cx="45" cy="40" r="3.4" />
        </g>
      </svg>
      {showWordmark && (
        <span
          className="font-bold tracking-tight text-gray-900"
          style={{ fontSize: size * 0.62 }}
        >
          <span className="text-primary-600">Tensor</span>Maps
        </span>
      )}
    </span>
  );
}
